/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Wed Jan 22 2025 15:40:47 GMT+0100 (Central European Standard Time)
 * Language keys:  2
 * Language code:  fr
 *
 */

const language = {
  "button": {
    "continue": "Continuer"
  },
  "component": {
    "questionNumber": {
      "questionNumberCurrent": "Question %{numberCurrent}",
      "questionNumberMax": "de %{numberMax}",
      "optional": " (Facultatif)"
    },
    "textInputBox": "Je voudrais ajouter...",
    "answerType": {
      "button": {
        "finishTheSurvey": "Terminer l'enquête",
        "continue": "Continuer"
      }
    },
    "finishSurveyDisplay": {
      "thanks": "Merci pour votre retour !",
      "explanation": "Cela nous aide beaucoup à continuer à améliorer votre sécurité."
    },
    "alert": {
      "error": "Une erreur s'est produite lors de la mise à jour de vos réponses. Veuillez réessayer."
    },
    "loading": {
      "loading": "Chargement...",
      "cannotOpen": "Nous ne pouvons pas ouvrir l'enquête.",
      "openSurveyAgain": "Veuillez fermer l'onglet et rouvrir l'enquête. Si le problème persiste, veuillez contacter le support."
    }
  }
} as const

export default language